import axios from "axios"
import { cca_config } from '@/config'

export default {
    makeRequest(url) {
        return axios.create({
            baseURL: url,
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
    },

    clinique() {
        return this.makeRequest(cca_config.C_URL_CLINIQUE_API)
    },

    comptabilite() {
        return this.makeRequest(cca_config.C_URL_CAISSE_API)
    },

    stock() {
        return this.makeRequest(cca_config.C_URL_STOCK_API)
    },

    online() {
        return this.makeRequest('https://google.com')
    }
}
